import { IGetObraAreaChecklistHeaderUseCase } from "../../../presentation/useCases/read/get_obra_area_checklist_header_use_case";
import { ObraAreaChecklistHeader } from "../../models/obra_area_checklist_header";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraAreaChecklistHeaderUseCase
 */

export class GetObraAreaChecklistHeaderUseCase implements IGetObraAreaChecklistHeaderUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraAreaChecklistHeader(
    idObraAreaChecklist: number | undefined,
  ): Promise<ObraAreaChecklistHeader> {
    if (idObraAreaChecklist === undefined) throw new Error("Id de area invalido!");
    return await this.repository.getObraAreaChecklistHeader(idObraAreaChecklist);
  }
}
